import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { toggleOrderModelCompany } from 'services/ModelsCompaniesService';

interface IToggleOrderBuyerModelDTO {
  modelId: number;
  canOrderInternally?: boolean;
  canOrderExternally?: boolean;
}

export const useToggleOrderModelInternallyCompany = () => {
  const { t } = useTranslation();
  return useMutation(
    (dto: IToggleOrderBuyerModelDTO) => {
      return toggleOrderModelCompany(
        dto.modelId,
        dto.canOrderInternally,
        undefined
      );
    },
    {
      onSuccess: (_data, variables) => {
        toast.success(
          variables.canOrderInternally
            ? t('Enabled internal ordering')
            : t('Disabled internal ordering')
        );
        queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANIES_FOR_MODEL]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
      },
      mutationKey: ReactMutationKeys.TOGGLE_ORDER_MODEL_INTERNALLY_COMPANY,
    }
  );
};

export const useToggleOrderModelExternallyCompany = () => {
  const { t } = useTranslation();
  return useMutation(
    (dto: IToggleOrderBuyerModelDTO) => {
      return toggleOrderModelCompany(
        dto.modelId,
        undefined,
        dto.canOrderExternally
      );
    },
    {
      onSuccess: (_data, variables) => {
        toast.success(
          variables.canOrderExternally
            ? t('Enabled external ordering')
            : t('Disabled external ordering')
        );
        queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANIES_FOR_MODEL]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
      },
      mutationKey: ReactMutationKeys.TOGGLE_ORDER_MODEL_EXTERNALLY_COMPANY,
    }
  );
};
